import { useContext, useEffect, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import { RastersAttributes } from "../../../../contexts/poFormContext";
import { RasterType } from "../types/krFormView";
import { CheckboxFieldProps } from "../../../../components/checkboxField/types/checkboxFieldProps";
import { ConfirmModalProps } from "../../../../components/modalWindow/types/confirmModalProps";
import CheckboxField from "../../../../components/checkboxField/checkboxField";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { UploadProps } from "./shared/types/uploadProps";
import UploadRasters from "./shared/uploadRasters/uploadRasters";
import { getFieldRef, getItemRef, renderSectionCommentBtn } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
//import { createConfigValidation, validation } from "../../../../helpers/validation/validation";

const GeologicalCrossSection = (props: any) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [fileRow, setFileRow] = useState<RastersAttributes>();
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [sectionToggleCheckbox, setSectionToggleCheckbox] = useState(true);
    //const [tableError, setTableError] = useState<boolean>(false);
    //const [tableErrorMsg, setTableErrorMsg] = useState<string>("");
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    const maxFileSize: any = 1048576;  // ~ 1 MB
    const maxFileDimensions: any = 2000;
    const maxFileNumberForUpload: any = 30;
    const rasterType: RasterType = RasterType.CrossSection;

    // Toggle section checkbox 
    useEffect(() => {
        var landslideImages = krForm.landslideRasters?.filter((item) => {
            return item.details?.rodzaj === rasterType;
        })

        landslideImages?.length === 0 ? setSectionToggleCheckbox(true) : setSectionToggleCheckbox(false);

        // prepareTableData();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [krForm.landslideRasters]);

    // const refreshValidation = (values: any, name: string) => {
    //     const currValidation = createConfigValidation(name, false);
    //     const currValidationMsg = validation(currValidation, values);
    //     if (currValidationMsg) {
    //         setTableError(true);
    //         setTableErrorMsg(currValidationMsg);
    //     } else {
    //         setTableError(false);
    //         setTableErrorMsg('');
    //     }
    // }

    // Validation
    // useEffect(() => {
    //     if (krForm.config?.check && !krForm.config.isValid) {
    //         const currValidation = createConfigValidation("rastersElements", false);
    //         var data = (krForm as KrLandslideFormTypes).landslideRasters?.filter((raster: any) => {
    //             return (raster.details.rodzaj === rasterType)
    //         })
    //         const errorMsg = validation(currValidation, data);
    //         if (errorMsg !== '') {
    //             setTableError(true);
    //             setTableErrorMsg(errorMsg);
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [krForm.config?.check])
    
    var checkboxFieldPropsPhotoDocToggle: CheckboxFieldProps = {
        disabled: true,
        labelName: "Brak dostatecznych danych geologicznych do sporządzenia przekroju",
        inputChecked: sectionToggleCheckbox
    }

    // Rasters upload
    var uploadRastersProps: UploadProps = {
        maxFileSize: maxFileSize,
        maxFileDimensions: maxFileDimensions,
        maxFileNumberForUpload: maxFileNumberForUpload,
        rasterType: rasterType,
        acceptedFiles: [
            "image/jpg",
            "image/jpeg"
        ],
        acceptedFilesForSnackbar: ".jpg lub .jpeg",
        dropzoneText: <>
                        Przeciągnij i upuść plik w formacie .jpg/.jpeg, aby dodać go do formularza. 
                        <br></br>Pliki powyżej 1MB lub długość boku 2000 pix będą skalowane do odpowiedniego rozmiaru.
                        <br></br>Jednocześnie wgrać można maksymalnie 30 plików.
                    </>,
        isLandslide: props.isLandslide,
        infoSectionChangeHandler: () => { if (sectionToggleCheckbox) setSectionToggleCheckbox(false); },
        clickRowHandler: setFileRow,
        confirmationToggle: setConfirmation,
        //tableError: tableError,
        //tableErrorMsg: tableErrorMsg,
        //refreshValidation: refreshValidation
        getMapForComment: props.getMapForComment,
        editMode: props.editMode,
        setNewCommentFieldDetails: props.setNewCommentFieldDetails,
        KRFieldDictForRows: KROFieldDict.przekOs_przekrojGeologicznyOsuwiska,
        fieldFormNameForRows: "Przekrój geologiczny osuwiska",
        setCommentsFilter: props.setCommentsFilter,
        markedFieldForCommentFiltering: props.markedFieldForCommentFiltering,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    // Confirm delete file
    const confirm = () => {
        setConfirmation(false);
        deleteFile(fileRow);
    }

    const deleteFile = (row: any) => {
        var form: any = Object.assign({}, krForm);
        if (form !== null && form.landslideRasters) {
            form.landslideRasters = form.landslideRasters.filter((item: any) => { 
                return item.details.globalid !== row.globalid;  
            });
        }
        // var data = (form as KrLandslideFormTypes).landslideRasters?.filter((raster: any) => {
        //     return (raster.details.rodzaj === rasterType)
        // })
        //refreshValidation(data, "rastersElements");
        setkrForm(form);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć plik ${fileRow?.pliK_NAZWA}?`;
    }

    var confirmDeleteImage: ConfirmModalProps = {
        width: "660px",
        height: "auto",
        confirmTitle: "Tak, usuń plik",
        onConfirm: confirm,
        cancelTitle: "Anuluj",
        onCancel: cancel,
        question: getQuestion(),
        refocus: refocus
    }
    
    return (
        <>
            <div ref={(node: any) => {getFieldRef(node, KROFieldDict.przekOs_sekcja, props.getMapForComment!)}} style={{width: "100%"}}>
                <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.GeologicalCrossSection, props.getMapForNavScroll!)}
                    onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.przekOs_sekcja); }}
                >15. Przekrój geologiczny osuwiska</h2>
                {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.przekOs_sekcja, false, "15. Przekrój geologiczny osuwiska", props.setNewCommentFieldDetails!, KROFieldDict.przekOs_sekcja)}
                <CheckboxField {...checkboxFieldPropsPhotoDocToggle} /> <br />
                <UploadRasters {...uploadRastersProps} />
            </div>
            {confirmation && <ConfirmModal {...confirmDeleteImage} />}
        </>
    )
}

export default GeologicalCrossSection